module.exports = __webpack_public_path__ + "static/fonts/AvenirLTStd-Roman.43666b5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AvenirLTStd-Roman.woff
// module id = La9y
// module chunks = 1